module.exports = __webpack_public_path__ + "img/icon-top@3x.417f5f86.png";